<template>
  <div class="vehicle-pass-records container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--表格数据-->
    <div class="col-2">
      <!--等信息内容-->
      <div class="general-container">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane label="通行记录" name="0">
            <el-form ref="eventQueryForm" class="pagination-table-query-form" :inline="true"
                     @keyup.enter.native="handleEventFormQuery()">
              <el-form-item label="通行时间">
                <uni-date-range-picker
                  v-model="eventDates"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </uni-date-range-picker>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleEventFormQuery()" type="primary">查 询</el-button>
                <el-button @click="resetEventQueryForm()">重 置</el-button>
              </el-form-item>
            </el-form>
            <div class="pagination-table-container">
              <el-table :data="eventTableData"
                        ref="eventTable"
                        v-loading="loading"
                        border highlight-current-row
                        element-loading-background="rgba(255, 255, 255, 0.8)"
                        element-loading-spinner="el-icon-loading"
                        element-loading-text="努力加载中..."
                        style="width: 100%"
                        @selection-change="handleEventTableSelectionChange">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column label="序号" type="index" width="60"></el-table-column>
                <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                  <template slot-scope="scope">{{getNameById(scope.row.regionId, $globalData.regions)}}</template>
                </el-table-column>
                <el-table-column label="道闸名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
<!--                <el-table-column label="道闸状态" prop="workStateText" width="80"></el-table-column>-->
                <el-table-column label="方向" prop="direction" width="80">
                  <template slot-scope="scope">{{getNameById(scope.row.direction, $type.diDirections)}}</template>
                </el-table-column>
                <el-table-column label="操作类型" prop="operationKind" width="100">
                  <template slot-scope="scope">{{getNameById(scope.row.operationKind, $type.diDoorOperations)}}</template>
                </el-table-column>
                <el-table-column label="车辆种类" prop="vehicleKind" width="100">
                  <template slot-scope="scope">{{getNameById(scope.row.vehicleKind, $type.vehicleKinds)}}</template>
                </el-table-column>
                <el-table-column label="车牌号码" prop="licenseNumber" width="100"></el-table-column>
                <el-table-column label="卡号" prop="cardNum" width="120"></el-table-column>
                <el-table-column label="驾驶员" prop="personName" width="80"></el-table-column>
                <el-table-column label="部门" prop="departmentName" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="放行状态" prop="letPass" width="100">
                  <template slot-scope="scope">{{getNameById(scope.row.letPass, $type.diLetPasss)}}</template>
                </el-table-column>
                <el-table-column label="进出时间" prop="happenTime" width="160">
                  <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
                </el-table-column>
<!--                <el-table-column label="操作" width="100">-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-button-->
<!--                      class="col-btn"-->
<!--                      type="text"-->
<!--                      icon="el-icon-view"-->
<!--                      @click="handleEventView(scope.row)"-->
<!--                    >查看-->
<!--                    </el-button>-->
<!--                  </template>-->
<!--                </el-table-column>-->
              </el-table>
              <el-pagination v-show="eventTableTotalRow > eventTableQueryParams.pageSize"
                             background
                             @current-change="handleEventCurrentPageChange"
                             @size-change="handleEventPageSizeChange"
                             :current-page.sync="eventTableQueryParams.pageNum"
                             :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                             :page-size.sync="eventTableQueryParams.pageSize"
                             prev-text="上一页"
                             next-text="下一页"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="eventTableTotalRow">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import VehiclePassRecords from './VehiclePassRecords.js'

export default VehiclePassRecords
</script>

<style lang="scss">
// @import "OperationLogs.scss";
</style>



// WEBPACK FOOTER //
// src/views/events/VehiclePassRecords/VehiclePassRecords.vue